import PaginatedSelect from "@/components/ui/PaginatedSelect";
import { useUser } from "@/context/user-context";
import { useGetReportsByPromptId } from "@/queries/evals/useGetReportsByPromptId";
import { Report } from "@/types/evaluate";
import { UseQueryResult } from "@tanstack/react-query";
import { observer } from "mobx-react-lite";
import { useHistoryFilters } from "./history-filter-store";

interface PipelineSelectorProps {
  promptId: number;
}

const PipelineSelector = ({ promptId }: PipelineSelectorProps) => {
  const filterStore = useHistoryFilters();
  const workspaceId = useUser()?.activeWorkspaceId;

  const Query = (
    page: number,
  ): UseQueryResult<{ reports: Report[]; total: number }, unknown> | null => {
    const result = useGetReportsByPromptId({
      workspace_id: workspaceId!,
      prompt_id: promptId,
      page,
      is_blueprint: true,
      per_page: 10,
    });

    if (!result.data)
      return result as unknown as UseQueryResult<
        { reports: Report[]; total: number },
        unknown
      > | null;

    return {
      ...result,
      data: {
        reports: result.data.reports,
        total: result.data.pages,
      },
    } as UseQueryResult<{ reports: Report[]; total: number }, unknown>;
  };

  return (
    <div>
      <label htmlFor="pipeline" className="mb-1 block text-sm font-medium">
        Pipeline
      </label>
      <PaginatedSelect<Report, { reports: Report[]; total: number }>
        query={Query}
        renderItem={(pipeline) => pipeline.name}
        getItemValue={(pipeline) => pipeline.id.toString()}
        extractData={(data) => ({
          data: data.reports,
          totalPages: data.total,
        })}
        placeholder="Select pipeline"
        value={{
          id: filterStore.selectedEvaluation?.id!,
          item: filterStore.selectedEvaluation!,
        }}
        onRemove={() => filterStore.removeEvaluation()}
        onValueChange={(value) => {
          filterStore.setEvaluation({
            id: value.id,
            name: value.item.name,
          });
        }}
      />
    </div>
  );
};

export default observer(PipelineSelector);
